/*jshint unused:false*/
import axios from 'axios';
import Vue from 'vue';
import moment from 'moment';
import validateFormFields from '../components/form-validation.js';
import Steps from './components/_pickup-steps.vue';
import Autocomplete from '../components/vue/_autocomplete.vue';
import getPickupDates from './mixins/method-getPickupDates';
import selectPickupDate from './mixins/method-selectPickupDate';
import submitPickupRequest from './mixins/method-submitPickupRequest';
import filterFormatDate from './mixins/filter-formatDate.js';
import generateEventLinks from './mixins/method-eventLinks.js';


const Pickup = new Vue({
  el: '#content',
  components: { Steps, Autocomplete },
  mixins: [ 
    getPickupDates, 
    selectPickupDate, 
    submitPickupRequest, 
    filterFormatDate, 
    generateEventLinks 
  ],
  data: function () {
    return {
      formAction: '',
      token: '',
      q: '',
      suggestions: [],
      googleErrorStatus: '',
      currentStep: 1,
      dates: [],
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      phoneType: '',
      reminder: '',
      notes: '',
      address: '',
      date: '',
      newsletter: false,
      specialDateId: '',
      status: '',
      pickupId: '',
      pickupDetails: '',
      paymentUrl:''
    }
  },
  mounted () {
    // set this for submitting the final pickup
    this.formAction = this.$refs.pickupForm.getAttribute('action');
    this.token = this.$refs.pickupForm.querySelector('[name="__RequestVerificationToken"]').value;

    dataLayer.push({ 
    'event': 'schedule',
    'subType': 'Location and Date'
    })
  },
  methods: {
    // used for: autocomplete component
    getSuggestions () {
      // clear the results when the text input has changed
      this.dates = [];
      this.address = '';
      this.status = '';
      this.googleErrorStatus = '';
      if (this.q.length <= 2) {
        // if the value is empty clear results
        this.suggestions = [];
      } else {
        const service = new google.maps.places.AutocompleteService();

        service.getPlacePredictions({
          input: this.q,
          types: ['address'],
          componentRestrictions: { country: 'ca' }
        }, (predictions, status) => {
          if (predictions) {
            this.suggestions = predictions;
          } else {
            // capture the status for the enter event since
            this.googleErrorStatus = status;
            this.suggestions = [];
          }
        });
      }
    },
    // Pass valid address to API
    handleUserInput (address) {
      this.status = 'BUSY';

      this.suggestions = [];

      if (this.googleErrorStatus) {
        // Since we already know the result of this, fake loading so users feel confident the search worked
        setTimeout(() => {
          this.status = this.googleErrorStatus;
        }, 500);

        dataLayer.push({
          'event': 'nopickupfound', 
          'reason' : this.googleErrorStatus,  
          'address' : address
        });
      } else {
        // set address to input address because vmodel doesn't get updated properly with google autocomplete
        this.address = address;

        if (this.address) {
          this.getPickupDates();
        }
      }
    },
    saveCustomerInfo () {
      validateFormFields.init(this.$refs.pickupForm.getAttribute('id'), 'Pickup/ScheduleAPickupValidateModel')
      .then((res) => {
        // since we need to use the same post information from step 2 in step 3, lets set a variable to the return from the form validation and use that
        this.pickupDetails = res.fields;
        this.currentStep = 3;

        dataLayer.push({ 
          'event': 'schedule',
          'subType': 'Confirm'
        });
        console.log(this.pickupDetails)
      }).catch((error) => {
        console.log(error)
      });
    }
  }
});



// WEBPACK FOOTER //
// ./src/js/pickup/pickup.js